import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { aiKeysApi } from '../lib/api';

// La GET ritorna solo un "hint" della chiave (mai la chiave in chiaro)
export interface AiKeyInfo {
  provider: string;
  key_hint: string | null;
}

export function useAiKey() {
  return useQuery({
    queryKey: ['ai-keys'],
    queryFn: async () => {
      const res = await aiKeysApi.get();
      // Normalizza: l'API può ritornare { key_hint } oppure { keys: [...] }
      return (res ?? null) as { key_hint?: string | null; keys?: AiKeyInfo[] } | null;
    },
  });
}

export function useSetAiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ provider, key }: { provider: 'openai'; key: string }) =>
      aiKeysApi.set(provider, key),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ai-keys'] }),
  });
}

export function useDeleteAiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (provider: string) => aiKeysApi.remove(provider),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ai-keys'] }),
  });
}
